export default async function signIn({ authToken, token }) {
  sessionStorage.setItem("authToken", authToken);
  sessionStorage.setItem("token", token);

  return {
    authToken: authToken,
    token: token,
  };
}
